/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_landing_features_sociallearning_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동료들과 함께하는 협력적 학습 환경`)
};

const en_landing_features_sociallearning_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaborative learning environment with peers`)
};

const ja_landing_features_sociallearning_description1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仲間と共に協力的な学習環境`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const landing_features_sociallearning_description1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.landing_features_sociallearning_description1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("landing_features_sociallearning_description1", locale)
	if (locale === "ko") return ko_landing_features_sociallearning_description1(inputs)
	if (locale === "en") return en_landing_features_sociallearning_description1(inputs)
	return ja_landing_features_sociallearning_description1(inputs)
};
export { landing_features_sociallearning_description1 as "landing_features_socialLearning_description" }